
import React from 'react';
import Navbar from '../components/Navbar';
import AnimatedBackground from '../components/AnimatedBackground';

const Terms = () => {
  return (
    <div className="min-h-screen w-full overflow-hidden">
      <AnimatedBackground />
      <Navbar />
      
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-4xl mx-auto bg-black/50 backdrop-blur-lg rounded-xl p-8 border border-white/10 text-left">
          <h1 className="text-3xl font-bold mb-8 text-white">Terms and Conditions</h1>
          <p className="text-gray-300 mb-4">Last updated: March 31, 2025</p>
          
          <div className="prose prose-invert max-w-none">
            <p className="text-gray-300 mb-6">
              By accessing and using Cloudima (the "Platform"), you agree to comply with these Terms and Conditions. If you do not agree, please do not use our services.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">1. Service Description</h2>
            <p className="text-gray-300 mb-4">
              Cloudima allows users to design, configure, and deploy cloud infrastructure through a visual interface without the need to write code. We translate your designs into Terraform code to facilitate deployment in your cloud provider accounts.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">2. Registration and Accounts</h2>
            <p className="text-gray-300 mb-4">
              To use the platform, it is necessary to create an account. When registering, you agree to provide truthful information and keep it updated.
            </p>
            <p className="text-gray-300 mb-4">
              Users are responsible for protecting the confidentiality of their access credentials.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">3. Acceptable Use</h2>
            <p className="text-gray-300 mb-4">
              The following is not permitted:
            </p>
            <ul className="list-disc pl-6 text-gray-300 mb-6 space-y-2">
              <li>Using the platform for illegal or unauthorized purposes</li>
              <li>Uploading content that infringes on third-party rights</li>
              <li>Attempting to access source code or internal systems without authorization</li>
            </ul>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">4. Free and Paid Plans</h2>
            <p className="text-gray-300 mb-4">
              Cloudima offers free plans with limited functionality, and premium services through individual or customized enterprise licenses. We reserve the right to modify prices or plan features with prior notice.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">5. Intellectual Property</h2>
            <p className="text-gray-300 mb-4">
              Cloudima's software, design, functionalities, and visual content are the property of the Cloudima project.
            </p>
            <p className="text-gray-300 mb-4">
              Infrastructure designs, images, and code generated by users belong to them, although by using the platform they agree to share them with their organization or publicly if they so indicate.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">6. Sharing and Download</h2>
            <p className="text-gray-300 mb-4">
              Users can decide whether to share their infrastructures with other organizations or publicly. They can also download Terraform code and images generated from their designs.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">7. Account Cancellation</h2>
            <p className="text-gray-300 mb-4">
              You can delete your account at any time. We reserve the right to suspend or cancel accounts in case of misuse.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">8. Modifications</h2>
            <p className="text-gray-300 mb-4">
              We reserve the right to modify these Terms at any time. In case of substantial changes, we will notify registered users.
            </p>
            
            <h2 className="text-xl font-semibold text-white mt-8 mb-4">9. Contact</h2>
            <p className="text-gray-300 mb-4">
              For any questions related to these terms, you can write to us at: contact@cloudima.org
            </p>
          </div>
        </div>
      </div>
      
      <footer className="py-8 border-t border-gray-700/30 relative z-10 bg-black/30 backdrop-blur-sm">
        <div className="container px-4 mx-auto">
          <div className="mt-4 text-center">
            <span className="text-sm text-gray-400">© {new Date().getFullYear()} Cloudima. All rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Terms;
